import { motion } from "framer-motion";
import { HeartPulse, ArrowRight, Copy } from "lucide-react";
import { toast } from "sonner";

const UPI_ID = "9406154830@ptsbi";
const QR_IMAGE_URL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_certified-dog-care/artifacts/3pg41xqn_Screenshot_20260813-102054.png";

export const DonationSection = () => {
  const copyUpi = () => {
    navigator.clipboard.writeText(UPI_ID);
    toast.success("UPI ID copied — thank you for your support!");
  };

  return (
    <section
      id="donate"
      data-testid="donation-section"
      className="py-24 md:py-32 px-6 md:px-10 max-w-7xl mx-auto"
    >
      <div className="bg-[#0F2520] rounded-[2.5rem] overflow-hidden grid md:grid-cols-2 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="p-10 md:p-14"
        >
          <HeartPulse className="w-9 h-9 text-[#F4D06F] mb-5" />
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-[#D97736] mb-4">
            Support A Life
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight text-white mb-4">
            Help Us Fund Medicine &amp; Emergency Care
          </h2>
          <p className="font-light text-white/70 leading-relaxed mb-8 max-w-md">
            Every donation helps us cover vaccinations, deworming, and emergency vet treatment for
            our dogs. If our work has touched your heart, please consider donating — every rupee
            reaches a dog in need.
          </p>

          <div className="flex items-center gap-3">
            <motion.div
              animate={{ x: [0, 10, 0] }}
              transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
              className="flex items-center gap-2 text-[#F4D06F] font-display text-lg font-semibold"
            >
              Please Donate <ArrowRight className="w-5 h-5 hidden md:inline-block" />
            </motion.div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="relative p-10 md:p-14 flex flex-col items-center bg-[#16332C]"
        >
          <div className="bg-white rounded-[1.5rem] p-4 shadow-2xl">
            <img
              data-testid="donation-qr-image"
              src={QR_IMAGE_URL}
              alt="Scan to donate via UPI"
              className="w-56 h-auto rounded-lg"
            />
          </div>
          <button
            data-testid="donation-upi-copy-button"
            onClick={copyUpi}
            className="mt-5 flex items-center gap-2 text-sm text-white/80 hover:text-[#F4D06F] transition-colors bg-white/5 hover:bg-white/10 px-4 py-2 rounded-full"
          >
            UPI: {UPI_ID} <Copy className="w-3.5 h-3.5" />
          </button>
          <p className="text-xs text-white/40 mt-3 text-center max-w-xs">
            Scan the QR with any UPI app (GPay, PhonePe, Paytm) to donate directly.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
